
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import TitelType from '@/types/Titel';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('titel', ['loaders']),
        },
        methods: {
            ...mapActions('titel', ['loadTitel', 'updateTitel', 'deleteTitel']),
        },
    })
    export default class TitelDetail extends Vue {
        @Prop() titel!: TitelType;
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
        };

        public updateTitel!: (titel: TitelType) => void;
        public deleteTitel!: (titel: TitelType) => void;

        public isEdit = false;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.isEdit = this.titel.titel !== null;
                this.titel.prevTitel = this.titel.titel;

                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateTitel(this.titel);
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Titel endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteTitel(this.titel);
                    }
                });
        }
    }
